var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-pageframe',{attrs:{"title":_vm.title}},[_c('v-container',_vm._l((_vm.search_results),function(item,index){return _c('m-inbox-email-log-entry-card',{key:index,attrs:{"value":item}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }